import ajaxRequest from './ajax'
import qs from "qs"
// 参会人 说明，或者播放地址
export const user_search_help = params => {
  return ajaxRequest.get('help/user_search_help?' + qs.stringify(params));
}
// 获取文档详情
export const get_help_detail = params => {
  return ajaxRequest.get('help/get_help_detail?' + qs.stringify(params));
}



// WEBPACK FOOTER //
// ./src/api/litter_helper.js